import { WeeklySchedule } from '../schedules/schedules.ruleset';

export const frenzySchedule: WeeklySchedule<{
  theme_id: Match2FrenzyTheme;
  progressionSet: 'basic' | 'power';
  objectives: Array<'basicGreen' | 'rocketHorizontal' | 'rocketVertical'>;
}> = {
  type: 'weekly',
  schedule: [
    {
      start: { day: 'friday', hour: 23 },
      end: { day: 'tuesday', hour: 23 },
      theme_id: 'leaf',
      progressionSet: 'basic',
      objectives: ['basicGreen'],
    },
    {
      start: { day: 'tuesday', hour: 23 },
      end: { day: 'friday', hour: 23 },
      theme_id: 'firecracker',
      progressionSet: 'power',
      objectives: ['rocketHorizontal', 'rocketVertical'],
    },
  ],
};

export type Match2FrenzyTheme = 'firecracker' | 'leaf';
